
import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { useDrawsStore } from "../hooks";

const AddPointOfContactQuestionContent = observer(({ loanDetails, classes }) => {
  const { pointOfContactStore } = useDrawsStore();
  const formFields = pointOfContactStore.pointOfContactFormStore.form.fields;

  const handleFormChange = (e) => {
    pointOfContactStore.pointOfContactFormStore.onFieldChange('addPointOfContact', e.target.value);
    pointOfContactStore.setShowAllFormValues();
  }

  return (
    <Grid item container xs={12} md={12} className={classes}>
      <Grid container direction="column" item>
        <Grid item container direction='row' justifyContent='space-between'>
          <Grid item>
            <Typography variant="h6">
              ADD POINT OF CONTACT
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="caption" color="textSecondary">
            Would you like to assign a point of contact for this draw who will be responsible for taking the pictures?
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="column">
        <Grid item xs={12} sm={12}>
          <RadioGroup value={formFields.addPointOfContact.value} onChange={e => handleFormChange(e)}>
            <FormControlLabel value="Y" control={<Radio />} label="Yes" />
            <FormControlLabel value="N" control={<Radio />} label="No" />
          </RadioGroup>
        </Grid>
      </Grid>
    </Grid>
  )
});

export default AddPointOfContactQuestionContent;